const ui    = require( './ui.js' );
const utils = require( './utilities.js' );

function init() {
    const $sel = cacheSelectors();
    
    $sel.btn.$login.on('click', utils.debounce(() => {
        login();
    }));
    $sel.btn.$twofaLogin.on('click', utils.debounce(() => {
        login(true);
    }));
    $sel.btn.$backupLogin.on('click', utils.debounce(() => {
        login(true);
    }));

    $sel.$form.on('keyup', utils.debounce((e) => {
        utils.form.handleSubmit(e, login);
    }));

    $sel.input.$tokenInput.on('keyup', utils.debounce(twofaKeyUp));
    $sel.input.$backupInput.on('keyup', utils.debounce(twofaKeyUp));

    $sel.input.$fields.on('focusin', function() {
        $(this).removeClass('error');
    }).on('focusout', function(e) {
        utils.form.validateInput(e, $(this), $sel.input.$fields);
    });

    $sel.input.$passwordToggle.on('click', () => {
        utils.form.togglePassword($sel.input.$fields)
    });

    function twofaKeyUp(e) {
        $('.modal__notice').remove();
        utils.form.handleSubmit(e, () => {
            login(true);
        });
    }

    function login(isTwofa = false) {
        console.log('login click', isTwofa);
        let data = {};
        const fields = $sel.input.$fields;
        if(isTwofa && $sel.loginModal.is(':visible')) {
            if(!$sel.input.$tokenInput.val()) {
                $sel.input.$tokenInput.after('<p class="modal__notice error">Please enter your auth code.</p>');
                return;
            }
            fields.push($sel.input.$tokenInput);
        }
        if(isTwofa && $sel.backupModal.is(':visible')) {
            if(!$sel.input.$backupInput.val()) {
                $sel.input.$backupInput.after('<p class="modal__notice error">Please enter your backup code.</p>');
                return;
            }
            fields.push($sel.input.$backupInput);
        }
        if (utils.form.prepareRequest(fields, data) && !utils.form.isProcessing) {
            utils.form.isProcessing = true;
            ui.loader.show();
            const post = $.post('/wp-json/alterwood/v1/login', data);
            post.done((res) => {
                console.log(res);
                if (res.status === 'error') {
                    $sel.input.$fields.filter(res.input).addClass('error').after('<p class="input__message error">' + res.message + '</p>');
                    if(isTwofa) {
                        $('.modal__notice').remove();
                    }
                    if($sel.loginModal.is(':visible')) {
                        $sel.input.$tokenInput.after('<p class="modal__notice error">' + res.message + '</p>');
                    }
                    if($sel.backupModal.is(':visible')) {
                        $sel.input.$backupInput.after('<p class="modal__notice error">' + res.message + '</p>');
                    }
                } else if (res.status === 'twofa') {
                    $sel.input.$modalName.text(res.name);
                    ui.modal.show($sel.loginModal);
                    $sel.input.$tokenInput.focus();
                } else {
                    window.location.href = res.redirect;
                }
                utils.form.isProcessing = false;
                ui.loader.hide();
            });
        }
    }

    function cacheSelectors() {
        let $sel = {
            '$form': $('.form--login'),
            'loginModal': $('.modal.-login'),
            'backupModal': $('.modal.-backup-login'),
        };
        $sel.btn = {
            '$login': $sel.$form.find('.login'),
            '$twofaLogin': $sel.loginModal.find('.twofa-login'),
            '$backupLogin': $sel.backupModal.find('.backup-login'),
        };
        $sel.input = {
            '$fields': $sel.$form.find('.input'),
            '$passwordToggle': $sel.$form.find('.password--toggle'),
            '$tokenInput': $sel.loginModal.find('.input'),
            '$modalName': $sel.loginModal.find('.first_name'),
            '$backupInput': $sel.backupModal.find('.backup-input'),
        };
        return $sel;
    }
}

/**
 * Public API
 *
 * @type {Object}
 */
 module.exports = {
	init: init
};


// WEBPACK FOOTER //
// ./scripts/components/login.js